import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

export function initProductReviewsSwiper() {
  new Swiper('.js-product-reviews-swiper', {
    navigation: {
      prevEl: '.js-product-reviews-swiper-arrow-prev',
      nextEl: '.js-product-reviews-swiper-arrow-next',
    },
    spaceBetween: 30,
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      425: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  })
}
